import { type ContextData } from '@common/defaults/ContextData';
import { getThemeConfigByContext, type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';
import { DesignElementAb2Icon } from '@common/svg/icons/components/DesignElementAb2Icon';
import { DesignElementBb4Icon } from '@common/svg/icons/components/DesignElementBb4Icon';
import { DesignElementBi1Icon } from '@common/svg/icons/components/DesignElementBi1Icon';
import { DesignElementMh1Icon } from '@common/svg/icons/components/DesignElementMh1Icon';
import { DesignElementWh1Icon } from '@common/svg/icons/components/DesignElementWh1Icon';
import { Color } from '@common/types/Color';
import { ThemeID } from '@common/types/ThemeID';
import { BrandedHeadingVariant, type Props as BrandedHeadingProps } from '@web/atoms/BrandedHeading';

export interface WidgetThemeConfig {
    brandedHeadingIcon?: BrandedHeadingProps['icon'];
    brandedHeadingVariant: NonNullable<BrandedHeadingProps['variant']>;
    brandedHeadingAccentColor: NonNullable<BrandedHeadingProps['accentColor']>;
    hideBorderBottomUnderline?: boolean;
}

const THEME_CONFIG: ThemeConfig<WidgetThemeConfig> = {
    defaults: {
        brandedHeadingVariant: BrandedHeadingVariant.BORDER_BOTTOM,
        brandedHeadingAccentColor: Color.PRIMARY,
        hideBorderBottomUnderline: false,
    },
    byPlatform: {
        ab: {
            brandedHeadingIcon: DesignElementAb2Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
        bb: {
            brandedHeadingIcon: DesignElementBb4Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
        bi: {
            brandedHeadingIcon: DesignElementBi1Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
        br: {
            hideBorderBottomUnderline: true,
        },
        mh: {
            brandedHeadingIcon: DesignElementMh1Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
        rw: {
            brandedHeadingVariant: BrandedHeadingVariant.BORDER_LEFT,
        },
        wh: {
            brandedHeadingIcon: DesignElementWh1Icon,
            brandedHeadingVariant: BrandedHeadingVariant.ICON,
        },
    },
    byTheme: {
        [ThemeID.VI]: {
            brandedHeadingAccentColor: Color.PRIMARY,
        },
        [ThemeID.VP]: {
            brandedHeadingAccentColor: Color.TERTIARY,
        },
        [ThemeID.VN]: {
            brandedHeadingAccentColor: Color.TERTIARY,
        },
        [ThemeID.VPBE]: {
            brandedHeadingAccentColor: Color.PRIMARY,
        },
    },
};

export const getWidgetThemeConfig = (contextData: ContextData) =>
    getThemeConfigByContext({ config: THEME_CONFIG, contextData });

export const useWidgetThemeConfig = () => useThemeConfig(THEME_CONFIG);
